import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CATEGORY_DOWNLOAD_URL } from "../../helpers/api.routes";
import { multipartFormData } from "../../helpers/api.services";
import DraggableBootstrapTable from "../../shared/components/draggableList/Draggable";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { CreateForm } from "./components/CreateForm";
import { IDownloadCategory } from "./interface";
import { AdminCategoryDownloadService } from "./service";

export const AdminCategoryDownload = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [state, setState] = useState<IDownloadCategory>({
    website: "",
    name: "",
    imageName: "",
  });
  const [selectedPrompt, setSelectedPrompt] = useState<IDownloadCategory>();
  const [file, setFile] = useState<File>();
  const [list, setList] = useState<IDownloadCategory[]>([]);

  const editHandler = (brandId: number) => {
    setIsMenuOpened(true);
    AdminCategoryDownloadService.getSingle(brandId)
      .then((response) => {
        const { data } = response;
        setState(data);
        window.scrollTo(0, 0);
      })
      .catch((error) => ErrorToast(error));
  };

  const updatePosition = (newList: any) => {
    const newListUpdated = newList?.map((item: any) => item.id);
    AdminCategoryDownloadService.updatePosition({ ids: newListUpdated });
  };

  const deleteHandler = () => {
    selectedPrompt?.id &&
      AdminCategoryDownloadService.delete(selectedPrompt?.id)
        .then((response) => {
          if (response?.status === "success") {
            SuccessToast(t(`download_category.successfully_deleted`));
            setTriggerUpdate((prev: boolean) => !prev);
          }
        })
        .catch((error) => ErrorToast(error));
  };

  const submitHandler = () => {
    if (state?.id) {
      multipartFormData(
        file,
        `${CATEGORY_DOWNLOAD_URL}/${state?.id}`,
        JSON.stringify(state),
        "post",
        "file",
      )
        .then((response) => {
          SuccessToast(t(`download_category.successfully_updated`));
          setIsMenuOpened(false);
          setTriggerUpdate(!triggerUpdate);
          setState({
            website: "",
            name: "",
            imageName: "",
          });
        })
        .catch((error) => ErrorToast(error));
    } else {
      multipartFormData(
        file,
        `${CATEGORY_DOWNLOAD_URL}`,
        JSON.stringify(state),
        "post",
        "file",
      )
        .then((response) => {
          SuccessToast(t(`download_category.successfully_created`));
          setIsMenuOpened(false);
          setTriggerUpdate(!triggerUpdate);
          setState({
            website: "",
            name: "",
            imageName: "",
          });
        })
        .catch((error) => ErrorToast(error));
    }
  };
  useEffect(() => {
    AdminCategoryDownloadService.getAll({ perPage: 0, page: 1 })
      .then((response) => {
        const { data } = response;
        setList(data?.items);
      })
      .catch((error) => ErrorToast(error));
  }, [triggerUpdate]);
  return (
    <>
      {!isMenuOpened && (
        <div className="col-12">
          <div className="card">
            <div className="card-body d-flex align-items-center justify-content-between">
              <h4 className="card-title mg-b-0">
                {t("download_category.create_new_category_download")}
              </h4>
              <button
                className="btn btn-primary"
                onClick={() => setIsMenuOpened(true)}
              >
                {t("global.add")}
              </button>
            </div>
          </div>
        </div>
      )}

      {isMenuOpened && (
        <div className="col-12">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              submitHandler();
            }}
          >
            <CreateForm
              setFile={setFile}
              setIsMenuOpened={setIsMenuOpened}
              state={state}
              setState={setState}
            />
          </Form>
        </div>
      )}
      <div className="col-12">
        <DraggableBootstrapTable
          list={list}
          setList={setList}
          headers={["id", "name"]}
          title="category"
          onEdit={editHandler}
          selectedPrompt={selectedPrompt}
          setSelectedPrompt={setSelectedPrompt}
          handleShow={handleShow}
          show={show}
          setShow={setShow}
          deleteHandler={deleteHandler}
          updatePosition={updatePosition}
        />
      </div>
    </>
  );
};
